import React, { useState, useEffect } from 'react';
import { useApollo } from '../../../../../components/contexts/ApolloContext';
import { QUERY_GET_PICKING_AUDIT } from '../../../../../components/graphql/getPickingAudit';

import { get, filter, includes, some, head, groupBy, size, isEmpty, forEach, map } from 'lodash';

const useOrderItemsQuery = (variables, withPicking, withoutAdded) => {
  const client = useApollo();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});

  const formatResponse = (data, withPicking, withoutAdded) => {
      const response = {
        ...data,
        order :data.orderWithLoader
      }

      const pickedItems = get(response, 'items', []);
      const removedItems = get(response, 'removedItems', []);
      const orderItems = get(response, 'order.items', []);
      const pickedItemsOutStock = filter(pickedItems, item => includes(['OUT_STOCK_ACCEPTED'], get(item, 'status')));
      const addedByClient = withoutAdded ? [] : filter(pickedItems, item => includes(['ADDED_BY_CLIENT'], get(item, 'status')));
      const outStocksWithoutAudit = filter(pickedItems, ({ audits, status }) => isEmpty(audits) && status === 'OUT_STOCK_ACCEPTED');
      const isUnpickedAndWasAdded = filter(removedItems, ({ id, status }) => !some(orderItems, ['id', id]) && includes(['UNPICK_BY_STORE'], status));
      let outStockFiltered = [];

      forEach(pickedItemsOutStock, item => {
          if (!some(orderItems, ['sku', get(item, 'sku')])) outStockFiltered = [...outStockFiltered, item];
      });

      let addedItems = [];

      forEach([...addedByClient], item => {
          const price = `${get(item, 'price', '000')}`;
          const listPrice = price.substring(0, size(price) - 2);
          addedItems = [...addedItems, {
              ...item,
              basePrice: listPrice,
              listPrice,
              quantity: get(item, 'pickingQuantity', 1)
          }];
      });
      
      const items = map(orderItems, ({ id, ...item }) => {
        return { id, picking: withPicking ? head(get(groupBy([...removedItems, ...pickedItems], 'id'), id)) : head(get(groupBy(removedItems, 'id'), id)), ...item };
      });
  
      const finalItems = [...items, ...addedItems];
  
      const results = {
          ...response,
          isWhatsapp: get(response, 'order.isWhatsapp', false),
          items: filter(finalItems, ({ id }) => !includes(Object.keys(groupBy(removedItems, 'id')), id)),
          removedItems: [...filter(finalItems, ({ id }) => includes(Object.keys(groupBy(removedItems, 'id')), id)), ...isUnpickedAndWasAdded],
          addedByClient: filter(finalItems, ({ id }) => includes(Object.keys(groupBy(addedByClient, 'id')), id)),
          isUnpickedAndWasAdded,
          outStocksWithoutAudit
      };
  
      return results;
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const responseRaw = await client.query({
          query: QUERY_GET_PICKING_AUDIT,
          variables,
          fetchPolicy: 'network-only',
        });

        const response = get(responseRaw, 'data.getPickingInfoBy.results.0');
        const responseFormatted = formatResponse(response, true, withoutAdded)
        setData(responseFormatted);

        setLoading(false);
      } catch (error) {
        console.error('Error en query:', error);
        setLoading(false);
      }
    };

    fetchData()
  }, [variables?.id])

  return { loading, data };
};

export default useOrderItemsQuery;